import { LinkButton, Text, Tooltip } from '@etg/wings';
import Media from 'react-media';
import { css, mediaQueries } from '@eti/styles';
import { price as priceUtil } from '@eti/utils';
import { ScreenReaderPrice } from '@eti/components';
import { CartRow, Price } from '../../CartComponents';

const tooltipContentColumnGapStyles = css`
  margin-top: 4px;
`;

const pricePerAgeTooltipStyles = css`
  ${tooltipContentColumnGapStyles};
  display: grid;
  grid-template-columns: 3fr 1fr;
`;

type CarrierPriceBreakdown = {
  carrier: {
    name: string;
  };
  providerPrice: {
    value: number;
  };
};

export interface CartPerAgeTypeCarrierPriceBreakdownTypes {
  carrierPriceBreakdowns: CarrierPriceBreakdown[];
  pricePerAgeTypeLabel: string;
  pricePerAgeTypeTotalPrice: number;
  travelerIndex: number;
}

const CartPerAgeTypeCarrierPriceBreakdown = ({
  carrierPriceBreakdowns = [],
  pricePerAgeTypeLabel,
  pricePerAgeTypeTotalPrice,
  travelerIndex,
}: CartPerAgeTypeCarrierPriceBreakdownTypes) => (
  <CartRow data-testid={`cart-per-age-type-price-breakdown-traveler-${travelerIndex}`}>
    {carrierPriceBreakdowns.length > 1 ? (
      <Tooltip
        content={
          <>
            <Media query={`${mediaQueries.small.only}`}>
              {(isMobile) => (!isMobile ? <Text>{pricePerAgeTypeLabel}</Text> : null)}
            </Media>
            {carrierPriceBreakdowns.map(({ carrier, providerPrice }, carrierIndex) => (
              <CartRow
                className={pricePerAgeTooltipStyles}
                key={`cart-price-per-age-carrier-price-breakdown-${carrier?.name}-${carrierIndex}`}
              >
                {carrier?.name && <Text aria-hidden>{carrier.name}</Text>}
                <Price aria-hidden data-testid={`cart-traveler-${carrierIndex}-provider-cost`}>
                  {priceUtil.formatPrice(providerPrice.value ?? 0)}
                </Price>
                <ScreenReaderPrice price={priceUtil.formatPrice(providerPrice.value ?? 0)} />
              </CartRow>
            ))}
          </>
        }
        data-testid={`cart-price-per-age-tooltip-traveler-${travelerIndex}`}
        title={pricePerAgeTypeLabel}
        trigger="click"
      >
        <LinkButton data-testid={`cart-price-per-age-traveler-${travelerIndex}-link-button`}>
          {pricePerAgeTypeLabel}
        </LinkButton>
      </Tooltip>
    ) : (
      <Text>{`${pricePerAgeTypeLabel} ${carrierPriceBreakdowns[0]?.carrier?.name ?? ''}`}</Text>
    )}
    <Price aria-hidden>{priceUtil.formatPrice(pricePerAgeTypeTotalPrice)}</Price>
    <ScreenReaderPrice price={priceUtil.formatPrice(pricePerAgeTypeTotalPrice)} />
  </CartRow>
);

export default CartPerAgeTypeCarrierPriceBreakdown;
